import SourceFile from "../../../model/SourceFile";
import Color from "../colors/Color";
import TileInfo from "../screens/TileInfo";

import Asset from "./Asset";
import Grid from "./Grid";
import Layer from "./layers/Layer";
import Link from "./Link";

interface SnapshotSourceFile extends SourceFile {
    id?: string;
    pageName?: string;
    pageId?: string;
    shareId?: string;
    nodeId?: string;
}

export enum SnapshotSource {
    Sketch = "sketch",
    Photoshop = "psd",
    XD = "xd",
    Figma = "figma",
}

// We expect at least one of these (small, medium) to be in the thumbnail object
export interface ScreenThumbnails {
    small?: {
        status: "ready" | "processing" | "error";
        url: string;
    };
    medium?: {
        status: "ready" | "processing" | "error";
        url: string;
    };
}

export default interface Snapshot {
    _id: string;
    thumbnails?: ScreenThumbnails;
    width: number;
    height: number;
    backgroundColor?: Color;
    grid?: Grid;
    layers: Layer[];
    assets: Asset[];
    links: Link[];
    componentNames: string[];
    componentIds?: string[];
    url: string;
    tileInfo?: TileInfo;
    source: string;
    sourceFile?: SnapshotSourceFile;
    density?: string;
    densityScale: number;
    assetCount?: number;
}
